import { FC } from 'react';

import { StatusHeader } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { Link } from '@gem/ui-kit';

import Tasks from 'APP/Tasks';
import { UnauthorizedLayoutTemplate } from 'APP/components/UnauthorizedLayoutTemplate/UnauthorizedLayoutTemplate';

import { ILoginViewProps } from '../../Login.types';

export const LoginRouterErrorView: FC<ILoginViewProps> = (props) => {
  const { loginPresenter } = props;
  const { t } = useTranslation();
  return (
    <UnauthorizedLayoutTemplate
      isShowLogo={false}
      header={
        <StatusHeader
          status="error"
          title={t('auth_server_unavailable_title')}
        />
      }
      subtitle={
        <>
          {t('auth_server_unavailable_description')}
          <Link onClick={Tasks.app.openSupport}>{t('auth_support_contact')}</Link>
        </>
      }
      onBack={loginPresenter.onBackHandler || undefined}
    ></UnauthorizedLayoutTemplate>
  );
};
